module.exports = require("@splunk/visualization-context/GeoRegistry");